module.exports = __webpack_public_path__ + "img/fantasy-world.05ca0319.webp";